import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface PickModel {}

export interface PickBasicModel extends PickModel {}

export interface PickListRequest {
    from: string
    to: string
}

const pickApi = (apiInstance: AxiosInstance) => {
    const suitesPickList = async ({ warehouse }: { warehouse?: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(
            `/pick/get-suites-ready-to-pick?warehouse=${warehouse}`
        )
        return res
    }

    const readyParcelsPickList = async ({ warehouse }: { warehouse?: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(
            `/pick/get-basic-ready-to-pick?warehouse=${warehouse}`
        )
        return res
    }

    const pickParcel = async ({ parcelUuid }: { parcelUuid: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/pick/${parcelUuid}`)
        return res
    }

    const pickPDF = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/pick/export-ready-pick`)
        return res
    }

    return {
        suitesPickList,
        readyParcelsPickList,
        pickParcel,
        pickPDF
    }
}

export default pickApi
